import { productCardType, ResponseType, setState, shop } from '@/commonTypes';
import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import BlogsFiltersSection from '@/components/pages/blog/blogsContent/BlogsFiltersSection';
import { useSearchParams } from 'next/navigation';
import Api from '@/api';

export default function ShopProductsInfo({
  shop,
  products,
  pageNumber,
  setPageNumber,
  //   page,
}: {
  shop?: shop;
  products?: ResponseType<productCardType>;
  pageNumber: string | number;
  setPageNumber: setState<string | number>;
  //   page?: number | string | null;
}) {
  const searchPrams = useSearchParams();
  const activeCatgeory = searchPrams.get('category');
  const [categoryList, setCategoryList] = useState([{ id: 1, title: 'فیلتر', slug: 'filter' }]);
  useEffect(() => {
    Api.categoryList({ start: 0, limit: 1000 })
      .then((res) => {
        // setCategoryList(res?.data?.response);
      })
      .catch((err) => {
        console.error('categoryList failed:', err);
      });
  }, []);
  return (
    <div className={`${styles.wrapper}`}>
      <div className={`${styles.info}`}>
        <span>{products?.response_details?.count}</span> کالا در این فروشگاه
      </div>
      <BlogsFiltersSection
        category={categoryList}
        // totalCount={category?.response_details?.count}
        activeCategory={activeCatgeory ? activeCatgeory : ''}
        setPageNumber={setPageNumber}
        urlQuery={true}
        activeKey="slug"
        page={'/shops/' + shop?.slug}
        className={`${styles.filterCategory}`}
        buttonClass={`${styles.buttonClass}`}
        removeAllQuearies={false}
        queryKey={'category'}
      />
    </div>
  );
}
